import React, { Component } from 'react';
import store from "../../store/index"
import { connect } from "react-redux"
import { eventBus } from '../../utils/tool';
import { ethers, BigNumber } from 'ethers';
import SweetAlert2 from 'react-sweetalert2';
import throttle from 'lodash/debounce';
import Spinner from 'react-bootstrap/Spinner';
import ApproveModal from '../Staking/components/ApproveModal/index'
import copy from 'copy-to-clipboard'
import { getProviderWithChainId, initProvider, zeroAddress } from '../../utils/config';
import { Contract, Provider } from 'ethers-multicall';
import UserListTable from './Components/UserListTable/index'
import moment from 'moment-timezone';
const idoContract = "0x46f00F9ebAc49FEB47b61FB5196eFa4962955E82"
const payTokenContract = '0x55d398326f99059ff775485246999027b3197955' // 要支付的代币的合约
// const nodeRpc = "https://bsc-dataseed4.ninicoin.io"
const nodeRpc = 'https://rpc.coredao.org'
// const nodeRpc = 'https://exchainrpc.okex.org/'
// const CHAIN_ID = 66
// const CHAIN_ID = 
const CHAIN_ID = 1116
// const 
// const nodeRpc = "https://data-seed-prebsc-1-s1.binance.org:8545/"
const abi = [
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "Paused",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "Unpaused",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "invitor",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            }
        ],
        "name": "buySuccess",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "claimAmount",
                "type": "uint256"
            }
        ],
        "name": "claimRewardSuccess",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "claimAmount",
                "type": "uint256"
            }
        ],
        "name": "claimTokenSuccess",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "newBeginTime",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "newEndTime",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "inviter",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "rewardAmount",
                "type": "uint256"
            }
        ],
        "name": "reward",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "inviter",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            }
        ],
        "name": "updateInvitor",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "Pause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "USDT",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "XMFWalletAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_invitor",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_userClaimTokenCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_usersId",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "invitor",
                "type": "address"
            }
        ],
        "name": "buyToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_claimed_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_got_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyer_pay_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "canClaimToken",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "canBeClaim",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkCap",
        "outputs": [],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkStatus",
        "outputs": [],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkTheTokenBlance",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "totalPayAmount",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_soldUSDTAmount",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "totalUserCanClaimToken",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_sellToken",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "aaa",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "bbb",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "ccc",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "claimBalance",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "claimBuyerToken_2",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "claimToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "dogeToken",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "enableClaimBuyerToken",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getAllUser",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "getBalanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "getCanBeClaimBuyerToken_2",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "getRewardUSDT",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "userId",
                "type": "uint256"
            }
        ],
        "name": "getUserById",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "getUserId",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserSubordinateInfo",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "_ind",
                "type": "uint256"
            }
        ],
        "name": "getUserSubordinateInfoById",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserSubordinateTotalBuyU",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "totalBuy",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getUsersCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "hardCup",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "idoBeginTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "idoEndTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "usdtAmount",
                "type": "uint256"
            }
        ],
        "name": "ifBuy",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "inviterCountsForUser",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorNumbs",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorNumbs2",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "invitorRewardPercentList",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitor_got_reward_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitor_reward_amount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "isPause",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "lenOfInvitorRewardPercentList",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxPayToBuyAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "minPayToBuyAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "address",
                "name": "newInvitor",
                "type": "address"
            }
        ],
        "name": "multiInvitor",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "bool",
                "name": "status",
                "type": "bool"
            }
        ],
        "name": "multiSetWLs",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "price",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "rejectContract",
        "outputs": [],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "sellDogeTokenAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setBeginTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "token",
                "type": "address"
            }
        ],
        "name": "setDogeToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bool",
                "name": "status",
                "type": "bool"
            }
        ],
        "name": "setEnableClaimBuyerToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setEndTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setHardCup",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "newValue",
                "type": "uint256[]"
            }
        ],
        "name": "setInvitorRewardPercentList",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setMaxPayToBuyAmount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setMinPayToBuyAmount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setPrice",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newU",
                "type": "address"
            }
        ],
        "name": "setUSDT",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setUserMaxClaimCount",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newAddr",
                "type": "address"
            }
        ],
        "name": "setXMFWalletAddress",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "soldUSDTAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "unPause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "userMaxClaimCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "whitelistedUsers",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    }
]

const tokenAbi = [{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "guy", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "approve", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "src", "type": "address" }, { "name": "dst", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "wad", "type": "uint256" }], "name": "withdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "dst", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "transfer", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "deposit", "outputs": [], "payable": true, "stateMutability": "payable", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }, { "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "payable": true, "stateMutability": "payable", "type": "fallback" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": true, "name": "guy", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": true, "name": "dst", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "dst", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Deposit", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Withdrawal", "type": "event" }]


const initData = {
    img: "/img/logo.jpg",
    // blockchain: "/img/binance.png",
    blockchain: 'https://scan.coredao.org/images/icon.png',
    title: "MetaDoge",
    reg_date: "2022-11-30",
    raise: "100k",
    val: "2.8M",
    allocation: "$0",
    progress: "25%",
    mecha: "0/100,069 MECHA",
    busd: "0 BUSD",
    actionBtn: "Contribute", // 提取代币 参与IDO
    video_img: "/img/thumb_6.png",
    video_icon: "fa-solid fa-play",
    video_link: "https://www.youtube.com/watch?v=fzBTvDraO5U",
    idoToken: "",
    total: "", // 当前购买总数
    purchaseCap: "", // 每个人能买多少
    hardCap: 100000, // 硬顶
    startTime: "", // 开始时间戳
    endTime: "" // 结束时间戳
}

const summaryData = {
    title: "Project Summary",
    content_1: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content_2: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."
}

const overviewData = {
    title: "Project Overview",
    list_heading: "Lorem ipsum dolor sit",
    content: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.",
}

const tokenmetricsData = {
    title: "Token Metrics",
    content: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
}

const roadmapData = {
    title: "Roadmap",
    content_1: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content_2: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."
}

const socialData = [
    // {
    //     id: "1",
    //     link: "https://twitter.com/tp9520",
    //     icon: "fab fa-twitter"
    // },
    // {
    //     id: "2",
    //     link: "https://t.me/TP1314",
    //     icon: "fab fa-telegram"
    // },
    // {
    //     id: "3",
    //     link: "https://hklr.gitbook.io/xiang-gang-shi-zi-shan-ji-jin-hui",
    //     icon: "fas fa-globe"
    // },
    // {
    //     id: "4",
    //     link: "discord",
    //     icon: "fab fa-discord"
    // }
]

const overviewList = [
    {
        id: "1",
        content: "Far far away",
    },
    {
        id: "2",
        content: "Behind the word mountains",
    },
    {
        id: "3",
        content: "Far from the countries Vokalia and Consonantia",
    },
    {
        id: "4",
        content: "There live the blind texts",
    }
]

const tokenList = [
    {
        id: "1",
        title: "Fundraised:",
        content: "$500,000",
    },
    {
        id: "2",
        title: "Platfrom Raise:",
        content: "$120,000 + $5,000",
    },
    {
        id: "3",
        title: "Price:",
        content: "$0.05",
    },
    {
        id: "4",
        title: "Lock-up:",
        content: "25% unlocked on TGE, 4 months cliff, then 5% on a monthly basis",
    }
]

class ProjectSingle extends Component {
    constructor() {
        super()
        this.state = {
            totalCount: 0,
            invitorReward: 0,
            isAdmin: false,
            currentPage: 0,
            allList: [],
            invitorList: [],
            invitorPage: 0,
            showStakeModal: false,
            initData: {
                hardCap: 100000,
            },
            summaryData: {},
            overviewData: {},
            tokenmetricsData: {},
            roadmapData: {},
            socialData: [],
            overviewList: [],
            tokenList: [],
            invitorAddress: '',
            invotorInvitorAddress: '',
            buyAmount: 0, // 已购入数量
            preBuyAmount: 0, // 预计购入数量
            swal: {},
            inputValue: '',
            soldUSDTAmount: 0,
            startTime: 0,
            endTime: 0,
            kdBuyAmount: 0,
            hardCap: 100000,
            linkInvitor: '',
            buyLoading: false,
            ethBalance: 0,
            invitorNumbers: 0, // 下级人数
            invitorRefUSDTAmount: 0, // 下级购买的总USDT数量
            canClaimedAmount: 0,
        }
        this.handleInput = throttle(this.handleBuyInputAmount, 300)

    }
    showMessageModal(info) {
        this.setState({
            swal: {
                show: false,
                title: '',
                text: '',
            }
        }, () => {
            this.setState({
                swal: {
                    ...info
                }
            })
        })

    }

    async getAllList(page) {
        // 获取全部列表
        // 获取邀请者列表
        // 获取 邀请者地址、邀请者购买usdt总量、邀请者的下级数量

        const account = this.state.account
        const perPage = 15
        const offset = (page - 1) * perPage
        // const provider = this.initProvider()
        const provider = getProviderWithChainId(CHAIN_ID)
        let ethcallProvider = new Provider(provider)

        ethcallProvider = await initProvider(ethcallProvider, CHAIN_ID)

        const StructInfo = `tuple(uint256 id,address addr,address inviter,uint256 payAmount)`
        const abi = [
            `function getUserById(uint256 userId) public view returns (${StructInfo} memory)`,
            `function getUserSubordinateInfoById(address userAddress, uint256 index) public view returns (${StructInfo}})`,
            'function inviterCountsForUser(address userAddress) public view returns (uint256)'
        ]
        const contract = new Contract(idoContract, abi)
        const calls = []
        console.log('这里是abi', abi, this.state.totalCount, offset)

        for (let i = this.state.totalCount - offset - 1; i >= 0; i--) {
            calls.push(contract.getUserById(i))
        }
        const res = await ethcallProvider.all(calls)

        const calls2 = []
        res.forEach(item => {
            calls2.push(contract.inviterCountsForUser(item.addr))
        })
        const res2 = await ethcallProvider.all(calls2)

        const allList = res.map((item, ind) => {
            return {
                id: item.id.toString(),
                addr: item.addr,
                invitor: item.inviter,
                payAmount: item.payAmount.toString() / 1e18,
                inviteCount: res2[ind].toString()
            }
        })
        console.log('当前全部列表为', allList)
        if (allList.length > 0) {
            this.setState({
                allList,
                currentPage: page
            })
        }
    }

    async getInviterList(page) {
        // 获取邀请者列表
        // 获取 邀请者地址、邀请者购买usdt总量、邀请者的下级数量

        const account = this.state.account
        const perPage = 15
        const offset = (page - 1) * perPage
        // const provider = this.initProvider()
        const provider = getProviderWithChainId(CHAIN_ID)
        let ethcallProvider = new Provider(provider)

        ethcallProvider = await initProvider(ethcallProvider, CHAIN_ID)

        const StructInfo = `tuple(uint256 id,address addr,address inviter,uint256 payAmount)`
        const abi = [
            `function getUserSubordinateInfoById(address userAddress, uint256 index) public view returns (${StructInfo}})`,
            'function inviterCountsForUser(address userAddress) public view returns (uint256)'
        ]
        console.log('这里是abi', abi)
        const contract = new Contract(idoContract, abi)
        const calls = []
        for (let i = this.state.invitorNumbers - offset - 1; i >= 0; i--) {
            calls.push(contract.getUserSubordinateInfoById(account, i))
        }
        const res = await ethcallProvider.all(calls)

        const calls2 = []
        res.forEach(item => {
            calls2.push(contract.inviterCountsForUser(item.addr))
        })
        const res2 = await ethcallProvider.all(calls2)

        const invitorList = res.map((item, ind) => {
            return {
                id: item.id.toString(),
                addr: item.addr,
                invitor: item.inviter,
                payAmount: item.payAmount.toString() / 1e18,
                inviteCount: res2[ind].toString()
            }
        })
        console.log('邀请者列表为', invitorList)
        if (invitorList.length > 0) {
            this.setState({
                invitorList,
                invitorPage: page
            })
        }
    }

    handleBuyInputAmount() {
        console.log(this.state.inputValue)
        // 去列表中获取
        if (this.state.account) {
            const provider = new ethers.providers.JsonRpcProvider(nodeRpc)
            const contract = new ethers.Contract(idoContract, abi, provider)
            contract.ifBuy(ethers.utils.parseUnits(this.state.inputValue + '', 18))
                .then(res => {
                    // console.log('预计购买', res.toString() / 1e18)
                    this.setState({
                        preBuyAmount: res.toString() / 1e18
                    })
                })
        }
    }

    async initProvider() {
        let provider = null
        let chainId = CHAIN_ID
        if (window.ethereum) {
            provider = new ethers.providers.Web3Provider(window.ethereum)
        }
        if (!provider) {
            // 直接走获取provider的逻辑
            provider = getProviderWithChainId(chainId)
        }

        return provider


    }



    componentDidMount() {
        this.setState({
            initData: initData,
            summaryData: summaryData,
            overviewData: overviewData,
            tokenmetricsData: tokenmetricsData,
            roadmapData: roadmapData,
            socialData: socialData,
            overviewList: overviewList,
            tokenList: tokenList,
            account: ""
        });

        eventBus.addListener("walletConnect", this.walletConnect.bind(this))
        // 获取信息
        // setTimeout(() => {
        //     // 获取连接的钱包
        // }, 2000);
    }
    componentWillUnmount() {
        eventBus.removeListener("walletConnect", this.walletConnect.bind(this))
    }

    async handleBuyLogic(amount) {
        if (this.state.buyLoading) {
            return
        }
        const b = parseFloat(amount)
        // if (a < 0.3) {
        //     this.setState({
        //         swal: {}
        //     }, () => {
        //         this.setState({
        //             swal: {
        //                 show: true,
        //                 title: '最低购买0.3USDT'
        //             }
        //         })
        //     })
        //     return
        // }


        if (this.state.ethBalance < b) {
            this.setState({
                swal: {}
            }, () => {
                this.setState({
                    swal: {
                        show: true,
                        title: '余额不足'
                    }
                })
            })
            console.log('当前余额', this.state.ethBalance)
            return
        }


        // console.log(111)
        // store.dispatch({ type: 'add' })
        // alert("当前项目为示例项目, 仅供示范, 无法参与IDO")
        this.setState({
            buyLoading: true,
            // showStakeModal: true
        })

        // 支付core, 直接购买即可
        const provider = await this.initProvider()

        const a = new ethers.Contract(idoContract, abi, provider.getSigner())

        const approveAmount = ethers.utils.parseUnits(amount + '', 18)
        // const invitor = this.state.linkInvitor || ''
        try {
            const tx = await a.buyToken(zeroAddress, {
                value: approveAmount
            })
            console.log('发起质押', tx)
            const receipt = await tx.wait()
            console.log('质押成功', receipt)
            this.fetchData()
        } catch (e) {
            this.handleErr(e)
        }


        this.setState({
            buyLoading: false
        })



        // // 调起授权框
        // // 设置授权数量
        // // 调用其中的授权按钮
        // // 设置数量
        // this.stakeModalRef.setApproveInfo({
        //     amount: amount,
        //     tokenDecimals: 18,
        //     stakeContract: idoContract,
        //     tokenAddress: payTokenContract,
        //     currentWallet: this.state.account,
        //     stakeMax: false,
        //     amountBigNumber: ethers.utils.parseUnits(amount + '', 18) // 最终授权数量
        // }).then(() => {
        //     this.stakeModalRef.handleLogic() // 设置数量
        // })
    }

    walletConnect(v) {
        console.log('监控到账户连接', v)
        if (v.account) {
            // 执行初始化操作
            this.setState({
                account: v.account
            }, () => {
                this.fetchData()
            })
        }
    }

    getProgressBar() {
        // 获取进度条
        const percent = (this.state.kdBuyAmount / this.state.initData.hardCap * 100).toFixed(2)
        return percent
    }

    async fetchData() {
        const provider = new ethers.providers.JsonRpcProvider(nodeRpc)
        const search = window.location.search
        const params = new URLSearchParams(search);
        const invitor = params.get('invitor')
        if (invitor) {
            this.setState({
                linkInvitor: invitor
            })
        }

        console.log('连接钱包是', this.state.account)
        if (this.state.account) {
            // 获取当前地址的上级地址
            // 获取当前邀请链接的上级地址
            // 1. 获取已购买的代币数量(需要连接钱包)
            const contract = new ethers.Contract(idoContract, abi, provider)
            const token = new ethers.Contract(payTokenContract, tokenAbi, provider)
            contract._invitor(this.state.account)
                .then(res => {
                    if (res !== '0x0000000000000000000000000000000000000000') {
                        console.log('邀请人是', res)
                        this.setState({
                            invitorAddress: res
                        })
                    }

                })

            console.log('开始获取余额是')
            provider.getBalance(this.state.account)
                .then(res => {
                    console.log('余额是', res.toString() / 1e18)
                    this.setState({
                        ethBalance: parseFloat(res.toString() / 1e18)
                    })
                })

            contract.inviterCountsForUser(this.state.account)
                .then(res => {
                    console.log('下级人数', res.toString(), this.state.account)
                    this.setState({
                        invitorNumbers: parseInt(res.toString())
                    }, () => {
                        // 如果邀请数超过0, 则获取下级列表
                        if (this.state.invitorNumbers > 0) {
                            // 获取邀请奖励
                            contract.getRewardUSDT(this.state.account)
                                .then((rewardU) => {
                                    console.log('邀请奖励', rewardU.toString() / 1e18)
                                    this.setState({
                                        invitorReward: rewardU.toString() / 1e18
                                    })

                                })
                            this.getInviterList(1)
                        }
                    })


                })

            // 判断是否在白名单中, 如果在白名单中, 显示全部列表
            contract.whitelistedUsers(this.state.account)
                .then(res => {
                    console.log('是否在白名单中', res)
                    if (res) {
                        contract.getUsersCount().then(r => {
                            console.log('总人数', r.toString())
                            this.setState({
                                totalCount: parseInt(r.toString()),
                                isAdmin: true
                            }, () => {
                                // 获取全部列表第一页
                                this.getAllList(1)
                            })

                        })
                    }

                })


            // contract.invitor_refUSDTAmount(this.state.account)
            //     .then(res => {
            //         console.log('下级购买总量', res.toString() / 1e18)
            //         this.setState({
            //             invitorRefUSDTAmount: res.toString() / 1e18
            //         })
            //     })

            // 获取开始时间
            // 获取结束时间
            // 获取提币开关
            // 获取当前卖出的core数
            // 获取当前卖出的kd数
            contract.idoBeginTime().then(res => {
                console.log('开始时间', res.toString())
                this.setState({
                    startTime: res.toString()
                })
            })
            contract.idoEndTime().then(res => {
                console.log('结束时间', res.toString())
                this.setState({
                    endTime: res.toString()
                })
            })

            contract.claimBuyerToken_2().then(res => {
                console.log('是否可以领取', res)
                this.setState({
                    canClaim: res
                })
            })

            contract.soldUSDTAmount().then(res => {
                console.log('已经卖出的USDT数量', res.toString() / 1e18)
                this.setState({
                    soldUSDTAmount: res.toString() / 1e18
                })
                contract.ifBuy(res).then(r => {
                    console.log('当前购买KD数量', r.toString() / 1e18)
                    this.setState({
                        kdBuyAmount: parseFloat(r.toString() / 1e18)
                    })
                })

            })

            contract.getCanBeClaimBuyerToken_2(this.state.account)
                .then(res => {
                    console.log('可领取的代币数量', res.toString() / 1e18)
                    this.setState({
                        canClaimedAmount: res.toString() / 1e18
                    })
                })

            contract._usersId(this.state.account).then(res => {
                console.log('当前用户信息id', res)
                contract.getUserById(res).then(r => {
                    if (r.addr.toLowerCase() === this.state.account.toLowerCase()) {
                        console.log('当前用户信息', r)
                        this.setState({
                            buyAmount: r.payAmount.toString() / 1e18
                        })
                    }


                })
            })
            if (invitor) {
                contract._invitor(invitor)
                    .then(res => {
                        if (res !== '0x0000000000000000000000000000000000000000') {
                            this.setState({
                                invotorInvitorAddress: res
                            })
                        }

                    })
            }



            token.balanceOf(this.state.account)
                .then(res => {
                    console.log('payToken余额是', res.toString() / 1e18)
                    this.setState({
                        payTokenBalance: parseFloat(res.toString() / 1e18)
                    })
                })



        }

        // const ethcallProvider = new Provider(provider);
        // await ethcallProvider.init();
        // const abi = [
        //     'function ido() external view returns(address)',
        //     'function purchaseCap() public view returns(uint256)',
        //     'function totalPurchasedAmount() public view returns(uint256)',
        //     'function hardCup() public view returns(uint256)',
        //     'function startTime() public view returns(uint256)',
        //     'function endTime() public view returns(uint256)',
        //     'function whitelist(address _addr) public view returns(bool)',
        //     'function _dontNeedWLtoBuy(address _addr) public view returns(bool)',
        //     'function purchasedAmounts(address _addr) public view returns(uint256)',
        //     'function invitorAmount(address _addr) public view returns(uint256)',
        //     'function claimedAmounts(address _addr) public view returns(uint256)',
        //     'function claimedInvitorAmount(address _addr) public view returns(uint256)',
        //     'function _invitor(address _addr) public view returns(address)',
        // ]
        // const ido = new Contract(idoContract, abi)

        // // 获取用户代币余额
        // const calls = [
        //     ido.ido(),
        //     ido.purchaseCap(),
        //     ido.totalPurchasedAmount(),
        //     ido.hardCup(),
        //     ido.startTime(),
        //     ido.endTime(),
        // ]
        // const res = await ethcallProvider.all(calls)
        // console.log(res)
        // this.setState({
        //     initData: {
        //         ...this.state.initData,
        //         idoToken: res[0],
        //         purchaseCap: res[1].toString() / 1e18,
        //         total: res[2].toString() / 1e18,
        //         hardCap: res[3].toString() / 1e18,
        //         startTime: res[4].toString() / 1e18,
        //         endTime: res[5].toString() / 1e18
        //     }
        // })

        // // 已经连接钱包, 获取连接数量
        // if (this.state.account) {
        //     // 是否在白名单里
        //     // 是否在不需要白名单也能买的账户里
        //     // 付款数量
        //     // 可领取的推荐奖励数
        //     // 已领取的推荐奖励数
        //     // claimedAmounts 已领取代币数
        //     // 'function whitelist(address _addr) public view returns(bool)',
        //     //     'function _dontNeedWLtoBuy(address _addr) public view returns(bool)',
        //     //     'function purchasedAmounts(address _addr) public view returns(uint256)',
        //     //     'function invitorAmount(address _addr) public view returns(uint256)',
        //     //     'function claimedAmounts(address _addr) public view returns(uint256)',
        //     //     'function claimedInvitorAmount(address _addr) public view returns(uint256)',
        //     //     'function _invitor(address _addr) public view returns(address)',
        //     const account = this.state.account
        //     const c2 = [
        //         ido.whitelist(account),
        //         ido._dontNeedWLtoBuy(account),
        //         ido.purchasedAmounts(account),
        //         ido.invitorAmount(account),
        //         ido.claimedAmounts(account),
        //         ido.claimedInvitorAmount(account),
        //         ido._invitor(account),
        //     ]
        //     const r = await ethcallProvider.all(c2)
        //     console.log('钱包相关', r)
        //     this.setState({
        //         initData: {
        //             ...this.state.initData,
        //             inWhitelist: r[0],
        //             inNotWlToBuy: r[1],
        //             purchasedAmounts: r[2].toString() / 1e18,
        //             invitorAmount: r[3].toString() / 1e18,
        //             claimedAmounts: r[4].toString() / 1e18,
        //             claimedInvitorAmount: r[5].toString() / 1e18,
        //             _invitor: r[6].toString() / 1e18
        //         }
        //     })
        // }


    }

    handleErr(e) {
        console.log(e)
        let tt = ''
        if (e.reason) {
            tt = e.reason
        } else {
            tt = JSON.stringify(e)
        }

        if (tt.indexOf('cant claim') > -1) {
            tt = '暂未开放领取'
        }
        if (tt.indexOf('ount<axlamCunt') > -1) {
            tt = '领取次数达到上限'
        }
        if (tt.indexOf('zero token can be claim') > -1) {
            tt = '暂无可领取代币'
        }
        if (tt.indexOf('not enough token') > -1) {
            tt = '代币数量不足'
        }


        this.showMessageModal({
            show: true,
            title: '错误',
            text: tt

        })
    }

    // 根据合约, 获取IDO信息
    // 参与IDO
    // 领取代币
    // 上级地址
    // 分级数量
    // IDO有多种方式: 有硬顶 没硬顶 不显示已购买数量 参与数量 一份=多少代币 



    render() {
        return (
            <section className="item-details-area">
                <ApproveModal
                    invitor={this.state.linkInvitor || ''}
                    onRef={node => this.stakeModalRef = node} handleClose={() => {
                        this.setState({
                            showStakeModal: false
                        })
                    }} ok={() => {
                        this.fetchData()
                    }} show={this.state.showStakeModal} />


                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 col-lg-5">
                            <div className="card project-card no-hover">
                                <div className="media">
                                    <img className="card-img-top avatar-max-lg" src='https://token-monitor.s3.amazonaws.com/1688916632766cropped-1688916632737.png' alt="" />
                                    <div className="media-body ml-4">
                                        <h4 className="m-0">KD </h4>
                                        <div className="countdown-times">
                                            <h6 className="my-2">已购入数量:</h6>
                                            <div style={{ height: "20px" }} className="countdown d-flex" data-date={this.state.initData.reg_date} >
                                                {this.state.buyAmount.toFixed(2)} CORE
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="item-progress">
                                        <div className="progress mt-2 mt-md-2">
                                            <div className="progress-bar" role="progressbar" style={{ width: (this.getProgressBar() + '%') }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>{this.state.kdBuyAmount.toFixed(2)}KD</div>
                                        </div>
                                        <div className="progress-sale d-flex justify-content-between mt-3">
                                            <span>0KD</span>
                                            <span>100000KD</span>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '20px', justifyContent: 'space-between' }}>
                                        <span style={{ width: '97%', marginLeft: '5px' }} onClick={async () => {
                                            this.handleBuyLogic(50)

                                        }} className="btn btn-bordered-white btn-smaller" href="/login">
                                            {this.state.buyLoading && <span>
                                                <Spinner animation="border" style={{ 'height': '16px', 'width': '16px', 'marginRight': '6px' }} variant="light" />
                                                购买中...
                                            </span>}
                                            {!this.state.buyLoading && <div>
                                                购买50CORE
                                            </div>}
                                        </span>
                                        {/* <span style={{ width: '47%' }} onClick={async () => {
                                            // this.inputValue = 100
                                            this.handleBuyLogic(300)

                                        }} className="btn btn-bordered-white btn-smaller" href="/login">
                                            {!this.state.buyLoading && <div>
                                                购买300USDT
                                            </div>}

                                        </span> */}
                                    </div>
                                    {/* <div>
                                        <input onChange={(e) => {
                                            console.log(e)
                                            this.setState({
                                                inputValue: e.target.value
                                            }, () => {
                                                this.handleInput(e)
                                            })

                                        }} style={{ 'borderRadius': '20px' }} type="text" defaultValue={this.state.inputValue} placeholder="输入要购买的USDT数量" required="required" />
                                    </div> */}
                                    {/* {
                                        this.state.initData.hardCap > 0 && */}

                                    {/* } */}

                                </div>
                                {/* Project Footer */}
                                <div className="project-footer d-flex align-items-center mt-4 mt-md-5">
                                    <span onClick={async () => {
                                        // this.inputValue = 100
                                        this.setState({
                                            claimLoading: true
                                        })
                                        try {
                                            // 领取按钮
                                            const p = await this.initProvider()
                                            const contract = new ethers.Contract(idoContract, abi, p.getSigner())
                                            const tx = await contract.claimBuyerToken_2()
                                            await tx.wait()
                                            this.showMessageModal({
                                                show: true,
                                                title: '领取成功',
                                                icon: 'success'
                                            })
                                            this.fetchData()
                                        } catch (e) {
                                            this.handleErr(e)
                                        }

                                        this.setState({
                                            claimLoading: false
                                        })




                                    }} className="btn btn-bordered-white btn-smaller" href="/login">
                                        {this.state.claimLoading && <div>
                                            <Spinner animation="border" style={{ 'height': '16px', 'width': '16px', 'marginRight': '6px' }} variant="light" />
                                            领取中...
                                        </div>}
                                        {!this.state.claimLoading && <div>
                                            领取
                                        </div>}
                                    </span>
                                    <span style={{ marginLeft: '5px' }}>
                                        可领取: {this.state.canClaimedAmount} KD
                                    </span>


                                    {/* Social Share */}

                                    <div className="social-share ml-auto">
                                        <ul className="d-flex list-unstyled">
                                            {this.state.socialData.map((item, idx) => {
                                                return (
                                                    <li key={`sd_${idx}`}>
                                                        <a target="_blank" href={item.link} rel="noreferrer">
                                                            <i className={item.icon} />
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                {/* Blockchain Icon */}
                                <div className="blockchain-icon">
                                    <img style={{ width: '50px' }} src={this.state.initData.blockchain} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-7 items mt-5 mt-lg-0">
                            {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">您的邀请链接</h3>
                                <p>
                                    {window.location.origin}?invitor={this.state.account}
                                </p>
                                <p>
                                    <div onClick={() => {
                                        const url = window.location.origin + '?invitor=' + this.state.account
                                        copy(url)
                                        this.setState({
                                            swal: {}
                                        }, () => {
                                            this.setState({
                                                swal: {
                                                    show: true,
                                                    title: '已复制',
                                                    text: '已复制邀请链接到剪贴板'
                                                }
                                            });
                                        })


                                    }} className="btn btn-bordered-white btn-smaller">
                                        复制
                                    </div>
                                </p>

                            </div> */}
                            {/* {(this.state.invitorAddress) && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">上级地址</h3>
                                <p style={{ 'overflow': 'hidden', 'textOverflow': 'ellipsis', 'display': '-webkit-box', 'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': '2' }}>
                                    {this.state.invitorAddress}
                                </p>
                                <p>
                                    <div onClick={() => {
                                        copy(this.state.invitorAddress)
                                        this.setState({
                                            swal: {}
                                        }, () => {
                                            this.setState({
                                                swal: {
                                                    show: true,
                                                    title: '已复制',
                                                    text: '已复制上级地址到剪贴板'
                                                }
                                            });
                                        })
                                    }} className="btn btn-bordered-white btn-smaller">
                                        复制
                                    </div>
                                </p>

                            </div>} */}
                            {/* {this.state.invitorReward > 0 && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">已获得的邀请奖励:  {this.state.invitorReward} USDT</h4>
                            </div>}
                            
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">邀请人数:  {this.state.invitorNumbers} </h4>
                            </div> */}
                            {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">下级地址购买总量:  {this.state.invitorRefUSDTAmount.toFixed(2)}USDT </h4>
                            </div> */}
                            {this.state.startTime > 0 && this.state.endTime > 0 && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">IDO时间</h3>
                                <p>
                                    开始时间: {moment(this.state.startTime * 1000).utcOffset(8).format('YYYY-MM-DD HH:mm')}
                                </p>
                                <p>
                                    结束时间: {moment(this.state.endTime * 1000).utcOffset(8).format('YYYY-MM-DD HH:mm')}
                                </p>
                            </div>}
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">项目介绍</h3>
                                <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                    作为一个去中心化交易平台，鲲道Swap旨在为用户提供安全、高效和透明的交易环境。通过智能合约技术，用户可以在无需第三方干预的情况下进行资产交换，从而实现更快速、更便捷的交易体验。
                                    与传统的中心化交易所相比，鲲道Swap具有许多独特的优势。首先，它完全遵循去中心化原则，用户可以直接掌握自己的资产，无需担心资金安全问题。其次，鲲道Swap提供了更广泛的交易对选择，用户可以在多个数字资产之间自由交易，从而获得更多的投资机会。此外，鲲道Swap还支持流动性挖矿，用户可以通过提供流动性来获取额外的奖励。
                                </p>
                                <p>
                                    鲲道Swap的上线将为用户开启一个全新的金融世界。无论是交易加密货币、参与流动性挖矿还是进行杠杆交易，用户都可以在这个平台上找到自己感兴趣的项目和机会。此外，鲲道Swap还将不断推出新的功能和产品，以满足用户不断增长的需求。
                                </p>
                                <p>
                                    无论您是新手还是资深的加密货币交易者，鲲道Swap都将是您不容错过的交易平台。我们诚邀您加入我们的社区，一同见证鲲道Swap的上线，并体验最先进的去中心化交易服务。
                                </p>
                                <p>
                                    鲲道Swap，开启您的数字资产之旅！开始的结束几乎就在这里  致敬所有跟随留下来的真共识着
                                </p>
                            </div>
                            <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h3 className="m-0">IDO规则</h3>
                                <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                    私募总量100000枚KD代币 50枚core兑换100枚KD代币 总共1000份 未私募的代币将销毁 一个地址只能参加一次ido ido结束后领取KD
                                </p>
                            </div>

                        </div>

                        {/* {this.state.invitorNumbers > 0 && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                            <h5 style={{ 'margin': '0' }}>我的邀请列表</h5>
                            <div className='mt-2 d-flex flex-row' style={{ 'flexWrap': 'wrap' }} >
                                <div>已邀请用户数: {this.state.invitorNumbers}</div>
                                <div style={{ marginLeft: '10px' }}> 已获得的邀请奖励: {this.state.invitorReward} </div>
                            </div>
                            <div style={{ 'position': 'relative' }}>
                                <UserListTable
                                    key={'invitor-list-table'}
                                    stakeDecimals={18}
                                    rewardDecimals={18}
                                    total={this.state.invitorNumbers}
                                    perPage={15}
                                    list={this.state.invitorList}
                                    changePage={(page) => {
                                        this.getInviterList(page)
                                    }}
                                    copy={(addr) => {
                                        copy(addr)
                                        this.showMessageModal({
                                            show: true,
                                            title: '复制成功',
                                            html: `<p>${addr}</p>`,
                                            icon: 'success'
                                        })
                                    }}
                                />
                            </div>
                        </div>} */}
                        {this.state.isAdmin && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                            <h5 style={{ 'margin': '0' }}>全部用户</h5>
                            <div className='mt-2 d-flex flex-row' style={{ 'flexWrap': 'wrap' }} >
                                <div>总计: {this.state.totalCount}</div>
                            </div>
                            <div style={{ 'position': 'relative' }}>
                                <UserListTable
                                    key={'invitor2-list-table'}
                                    stakeDecimals={18}
                                    rewardDecimals={18}
                                    total={this.state.totalCount}
                                    perPage={15}
                                    list={this.state.allList}
                                    changePage={(page) => {
                                        this.getAllList(page)
                                    }}
                                    copy={(addr) => {
                                        copy(addr)
                                        this.showMessageModal({
                                            show: true,
                                            title: '复制成功',
                                            html: `<p>${addr}</p>`,
                                            icon: 'success'
                                        })
                                    }}
                                />
                            </div>
                        </div>}
                    </div>
                </div>
                <SweetAlert2 {...this.state.swal} />
            </section>
        );
    }
}

function mapStateToProps(state) {
    const account = state.account;
    return {
        account,
        // text
    };
}

// export default ProjectSingle;
export default connect(mapStateToProps)(ProjectSingle)